// extracted by mini-css-extract-plugin
module.exports = {"error":"Iz4k4"};